import React, { FC, useEffect, useState } from 'react';

import { Box, Button, TextField } from '@mui/material';
import { Link } from '@src/main/modules/common/link/domain/Link';

import Card from '@src/main/ui/components/common/Card/Card';
import Modal from '@src/main/ui/components/common/Modal/Modal';

interface Props {
  open: boolean;
  link: string | undefined;
  onClose: () => void;
  updateLink: (link: Link) => void;
}

const LinkFormModal: FC<Props> = ({ open, link, updateLink, onClose }) => {
  const [inputLink, setInputLink] = useState<string>('');

  useEffect(() => {
    if (link) {
      setInputLink(link);
    }
  }, [link]);

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateLink({ link: inputLink });
    onClose();
  };

  return (
    <>
      <Modal open={open} handleClose={onClose}>
        <Card width="90vw" maxWidth="650px" maxHeight="300px">
          <form onSubmit={submit}>
            <Box
              sx={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <TextField
                fullWidth
                variant="standard"
                label="Link"
                value={inputLink}
                onChange={(e) => setInputLink(e.target.value)}
                required
              />
              <Button
                sx={{
                  width: 'fit-content',
                  alignSelf: 'flex-end',
                }}
                type="submit"
                color="secondary"
                variant="contained"
              >
                Update
              </Button>
            </Box>
          </form>
        </Card>
      </Modal>
    </>
  );
};

export default LinkFormModal;
